import React, { useEffect, useRef, useState } from 'react';
import { Auth } from 'aws-amplify';
import cognitoConfig from '../../../shared/config/cognitoConfig';
import { LoadingSpinner, ErrorMessage, Button, Logo } from '@bafkal/ui-shared/components';
import { extractContractError } from '@bafkal/ui-shared/utils';

const Register = () => {
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const isMounted = useRef(true);

    useEffect(() => {
        return () => { isMounted.current = false; };
    }, []);

    useEffect(() => {
        const hasCognito = cognitoConfig.Auth && cognitoConfig.Auth.userPoolId && cognitoConfig.Auth.userPoolWebClientId && cognitoConfig.Auth.oauth && cognitoConfig.Auth.oauth.domain;

        (async () => {
            if (!hasCognito) {
                if (isMounted.current) setError('Cognito Managed Login is not configured. Please set REACT_APP_COGNITO_* environment variables.');
                return;
            }

            try {
                if (isMounted.current) {
                    setError(null);
                    setLoading(true);
                }

                // Redirect to Hosted UI - register flow will be handled by Cognito
                await Auth.federatedSignIn();
            } catch (err) {
                if (isMounted.current) {
                    const contractError = extractContractError(err, 'Failed to open Managed Login. Check Cognito configuration.');
                    setError(contractError.message);
                }
            } finally {
                if (isMounted.current) setLoading(false);
            }
        })();
    }, []);

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
                <div className="flex justify-center">
                    <Logo className="h-12 w-12 text-blue-600" />
                </div>
                <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Redirecting to AWS Managed Login</h2>
                <p className="mt-2 text-center text-sm text-gray-600">You will be redirected to the Cognito Hosted UI to register. If nothing happens, <Button onClick={() => Auth.federatedSignIn()} variant="link" className="hover:text-blue-700 focus:outline-none">click here</Button>.</p>
            </div>

            <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                    {error && <ErrorMessage message={error} />}

                    {!error && (
                        <div className="mt-6 flex items-center justify-center">
                            <LoadingSpinner size="lg" />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Register;